<template>
<div id="services" v-animate-onscroll="'animated fadeIn'">
    <h1>Services</h1>
    <!-- Loop through each service -->
    <div class="service_container" v-for="(service) in services" :key="service.id">
        <div class="service_icon">
            <img :src="getImageUrl(service.icon)" width="100%" :alt="service.id" />
        </div>
        <div class="service_description">
            <!-- Loop through each record of the service to display position and description -->
            <span style="line-height: 2;" v-for="(record, idx) in service.record" :key="idx">
                <strong>{{ record.position }}</strong>: {{ record.description }}
            </span>
        </div>
    </div>
</div>
</template>

<script>
export default {
    name: 'Services',
    data() {
        return {
            services: [
                {
                    id: "conference",
                    icon: "conference.png",
                    record: [
                        {
                            position: "NeurIPS Conference Reviewer",
                            description: "2025"
                        },
                        {
                            position: "ICLR Conference Reviewer",
                            description: "2026"
                        }
                    ]
                },
                {
                    id: "cuhk",
                    icon: "cuhk.png",
                    record: [
                        {
                            position: "Teaching Assistant",
                            description: "CSCI 3100: Software Engineering, 2025 Spring"
                        },
                        {
                            position: "Teaching Assistant",
                            description: "ENGG 2760A / ESTR 2018: Probability for Engineers, 2024 Fall, 2025 Fall"
                        }
                    ]
                },
                {
                    id: "lws",
                    icon: "lws.png",
                    record: [
                        {
                            position: "Hostel Tutor",
                            description: "Lee Woo Sing College (South Block), 2024/25, 2025/26"
                        }
                    ]
                },
            ],
        }
    },
    methods: {
        getImageUrl(figname) {
            return require(`@/assets/img/${figname}`);
        },
    }
};
</script>

<style scoped>
#services{
    position: relative;
    width: 1000px;
    margin: 0px auto;
    background-repeat: no-repeat;
    background-size: cover;
    color: #000000;
    font-family: "Comic Sans MS", "Comic Sans", "cursive";
}

.service_container {
    width: 1000px;
    height: 200px;
    display: flex;
    align-items: flex-start;
}

.service_icon {
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
    box-sizing: border-box;
}
.service_icon img{
    max-width: 125px;
    max-height: 125px;
}
.service_description {
    height: 100%;
    width: 80%;
    padding: 0 20px;
    margin: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
}
</style>